import type { CardDesignData } from '@flashcard/shared';
import { CARD_SIZE, SAFE_MARGIN } from './pdf';

export interface ValidationResult {
  valid: boolean;
  errors: string[];
  warnings: string[];
}

// Prüft, ob eine Box vollständig im Safe-Bereich liegt
function inSafeZone(x: number, y: number, w: number, h: number, cardW: number, cardH: number): boolean {
  const minX = SAFE_MARGIN;
  const minY = SAFE_MARGIN;
  const maxX = cardW - SAFE_MARGIN;
  const maxY = cardH - SAFE_MARGIN;
  return x >= minX && y >= minY && x + w <= maxX && y + h <= maxY;
}

export function validateDesign(design: CardDesignData): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  const { width, height } = CARD_SIZE[design.format];

  // 1. Pflichtfelder: mindestens ein Text mit Inhalt
  const hasText = design.texts.some((t) => t.content.trim().length > 0);
  if (!hasText) {
    errors.push('Mindestens ein Textfeld (z. B. Name) muss ausgefüllt sein.');
  }

  // 2. Logo vorhanden
  if (!design.logoUrl || !design.logoBox) {
    errors.push('Ein Logo ist erforderlich.');
  }

  // 3. Text im Safe-Bereich
  for (const t of design.texts) {
    if (!t.content.trim()) continue;
    if (t.x < SAFE_MARGIN || t.y < SAFE_MARGIN || t.x > width - SAFE_MARGIN || t.y > height - SAFE_MARGIN) {
      errors.push(`Text „${t.content}" liegt außerhalb des Sicherheitsbereichs.`);
    }
  }

  // 4. QR-Code im Safe-Bereich
  if (design.qrCode) {
    if (!inSafeZone(design.qrCode.x, design.qrCode.y, design.qrCode.size, design.qrCode.size, width, height)) {
      errors.push('Der QR-Code liegt außerhalb des Sicherheitsbereichs.');
    }
  }

  // 5. Logo-Auflösung (Warnung)
  if (design.logoBox && design.logoBox.width > 0) {
    const requiredPx = design.logoBox.width * 11.81; // 300 DPI ≈ 11.81 px/mm
    // Hinweis: die tatsächliche Bildauflösung kann hier nicht geprüft werden;
    // sie wird beim Logo-Upload erfasst. Wir weisen allgemein darauf hin.
    if (requiredPx > 1000) {
      warnings.push('Logo sollte mindestens 300 DPI in Druckgröße haben.');
    }
  }

  return { valid: errors.length === 0, errors, warnings };
}
